import React, { useEffect, useState } from "react";
// import { Row, Col } from "react-bootstrap";
import CMS from "../../Assessts/Images/Home/ScholarshipTypes/CMS.png";
import DMS from "../../Assessts/Images/Home/ScholarshipTypes/DMS.png";
import HSS from "../../Assessts/Images/Home/ScholarshipTypes/HSS.png";
import { FaLessThan, FaGreaterThan } from "react-icons/fa";

const AUSTypes = () => {
    const [Index, SetIndex] = useState(0);
    const ScholarshipTypes = [
        { Img: CMS, Tittle: "College Merit Scholarships", Content: "NorthSouth offers scholarships for students who have gained admission to professional courses like Engineering, Lateral Engineering, MBBS, Dental, BSc(N), Diploma/Polytechnic/ Diploma in Agriculture, B.Sc(Ag), B.Pharma, BA.BEd/B.Sc.BEd(Limited to Regional Institutes of Education of NCERT Ajmer, Bhopal, Bhubaneswar, Mysore, Shillong) NorthSouth supports students through their entire course of study as long as he or she doesn’t fail in the examination. To find out more details please Click Here for more details." },
        { Img: DMS, Tittle: "Designated Merit Scholarships", Content: "While a donation to NorthSouth goes towards the general pool of college scholarships, some time if a donor wishes to support a student from one college or a student in a specific course of study NorthSouth finds an eligible student and gives a designated scholarship. Donors who have donated towards this category will be listed in this page in the upcoming weeks." },
        { Img: HSS, Tittle: "High School Scholarships", Content: "NorthSouth also helps students to complete their high school. The high school scholarships are usually designated by a donor who wishes to help students in his or her high school of choice. A list of high schools will be uploaded in the upcoming weeks." },
    ];
    useEffect(() => {
        const interval = setInterval(() => {
            SetIndex((prev) => (prev + 1) % ScholarshipTypes.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);
    return (
        <>
            <div className="mt-4 AUST" style={{ display: "grid", gridTemplateColumns: "auto 1fr" }}>

                <div className="AUST-Menu dflex flexd-column alignitems">
                    <div className="Web-MainHeading mb-3" >Scholarship Types</div>
                    <div className="dflex gap-3 flexd-column AUST-SUBOptions">
                        <span onClick={() => SetIndex(0)} style={{ backgroundColor: Index === 0 ? "#347462" : "" }}>College Merit Scholarships</span>
                        <span onClick={() => SetIndex(1)} style={{ backgroundColor: Index === 1 ? "#347462" : "" }}>Designated Merit Scholarships</span>
                        <span onClick={() => SetIndex(2)} style={{ backgroundColor: Index === 2 ? "#347462" : "" }}>High School Scholarships</span>
                    </div>
                </div>
                <div className="AUST-Details mt-2" >

                        <div className="dflex alignitems Card" style={{ position: "relative" }}>
                            <div className="HBButtons LButton" onClick={() => { SetIndex((prev) => prev === 0 ? ScholarshipTypes.length - 1 : prev - 1) }}><FaLessThan /></div>
                            <div className="dflex gap-4 AUST-Details-Card">
                                <img src={ScholarshipTypes[Index].Img} Alt="Scholarship types" className="h-50" />
                                <div>
                                    <div className="Web-SubHeading">{ScholarshipTypes[Index].Tittle}</div>
                                    <div className="mt-2" style={{ textAlign: "justify" }}>{ScholarshipTypes[Index].Content}</div>
                                </div>
                            </div>
                            <div className="HBButtons RButton" onClick={() => { SetIndex((prev) => (prev + 1) % ScholarshipTypes.length); }}><FaGreaterThan /></div>
                        </div>

                        {/* <div className="dflex gap-3 JCCenter All_Dots">
                            {ScholarshipTypes.map((_, i) => (
                                <button key={i} onClick={() => SetIndex(i)}
                                    className={`DOts ${i === Index ? "Dots-Active" : ""}`} />
                            ))}
                        </div> */}
                    </div>
            </div>
        </>
    )
}
export default AUSTypes;